import { useDebounceFn } from '@vueuse/core';

const DEFAULT_ENDPOINT = route('api.telemetry.frontend-event');
const DEBOUNCE_MS = 500;

const getTelemetryEndpoint = () => import.meta.env.MIX_TELEMETRY_ENDPOINT || DEFAULT_ENDPOINT;
const getCsrfToken = () => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || null;

const sendViaBeacon = (endpoint, payload) => {
  const blob = new Blob([JSON.stringify({
    ...payload,
    _token: getCsrfToken(),
  })], { type: 'application/json' });

  return navigator.sendBeacon(endpoint, blob);
};

const debouncedSend = useDebounceFn((payload) => {
  const endpoint = getTelemetryEndpoint();
  return sendViaBeacon(endpoint, payload);
}, DEBOUNCE_MS);

const sendTelemetryEvent = async (payload) => {
  try {
    debouncedSend(payload);
  } catch (error) {
    console.error('[Telemetry] Failed to send event:', error);
    throw error;
  }
};

export default sendTelemetryEvent;
